import * as z from "zod";
import { zql } from "../generatedDrizzleSchema";
import {
  collectDestinationCidrs,
  destinationSchema,
} from "./egressRouteShared";
import { mutator } from "./mutator";
import { clientGeneratableIdSchema } from "../id";

const createEgressRouteSchema = z.object({
  id: clientGeneratableIdSchema,
  networkId: z.string(),
  destination: destinationSchema,
  enforced: z.boolean().optional(),
});

export const createEgressRoute = mutator({
  schema: createEgressRouteSchema,
  resolve: { network: { kind: "network", from: "networkId" } },
  permissions: [
    {
      permission: "tenant:egress_routes_manage",
      scopeId: ({ ctx }) => ctx.tenantId,
    },
    { permission: "network:use", scopeId: ({ args }) => args.network.id },
  ],
  fn: async ({ tx, ctx, args: { id, destination, enforced, network } }) => {
    const value =
      destination.type === "cidr" ? destination.range : destination.pattern;
    const existing = await tx.run(
      zql.egressRoutes.where("networkId", network.id)
    );
    await tx.mutate.egressRoutes.insert({
      id,
      networkId: network.id,
      destinationType: destination.type,
      destination: value,
      enforced: enforced ?? false,
      createdAt: Date.now(),
      disabledAt: null,
      tenantId: ctx.tenantId,
    });
    await tx.mutate.networks.update({
      id: network.id,
      configuration: {
        ...network.configuration,
        destinationCidrs: collectDestinationCidrs([
          ...existing,
          { destinationType: destination.type, destination: value },
        ]),
      },
    });
  },
});
